module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_person02-0c5a0600336af8add8dce67513535166.svg";